import { AppDispatch } from '../store/store';
import { getClaimByToken } from '../services/api';
import { resetForm, setClaimId, setClaimStatus, updateClaimField } from '../store/claimSlice';

const fieldsToHydrate = [
  'facility_state',
  'facility_city',
  'facility_id',
  'facility_unit',
  'reporter_first_name',
  'reporter_last_name',
  'reporter_phone',
  'owner_email',
  'owner_address_1',
  'owner_address_2',
  'owner_city',
  'owner_state',
  'owner_zip_code',
  'incident_date',
  'tpp_loss_type_id',
  'other_loss_type_description',
  'authority_name',
  'authority_filed_report',
  'items_current_location',
  'info_manager_notified',
  'another_claim_filed',
  'another_claim_loss_type_id',
  'another_claim_date',
  'damaged_items',
  'damage_description',
  'damage_estimate',
  'damage_discovered_by',
] as const;

export const hydrateClaimIntoStore = (existingClaim: Record<string, unknown>, dispatch: AppDispatch): void => {
  dispatch(resetForm());
  dispatch(setClaimId(Number(existingClaim.id)));
  dispatch(setClaimStatus(String(existingClaim.status ?? '').toUpperCase() || null));

  const facility = (existingClaim.facility as Record<string, unknown>) || {};

  fieldsToHydrate.forEach((field) => {
    let rawValue = existingClaim[field];
    if ((rawValue === null || rawValue === undefined || rawValue === '') && field === 'facility_state') {
      rawValue = facility.state;
    }
    if ((rawValue === null || rawValue === undefined || rawValue === '') && field === 'facility_city') {
      rawValue = facility.city;
    }
    if ((rawValue === null || rawValue === undefined || rawValue === '') && field === 'facility_id') {
      rawValue = facility.id;
    }
    if (field === 'info_manager_notified' || field === 'another_claim_filed') {
      if (rawValue === true || rawValue === 1 || rawValue === '1') rawValue = '1';
      else if (rawValue === false || rawValue === 0 || rawValue === '0') rawValue = '0';
    }
    const value = rawValue === null || rawValue === undefined ? '' : String(rawValue);
    dispatch(updateClaimField({ field, value }));
  });
};

export const resumeClaimByToken = async (token: string, dispatch: AppDispatch): Promise<Record<string, unknown>> => {
  const existingClaim = await getClaimByToken(token);
  hydrateClaimIntoStore(existingClaim, dispatch);
  return existingClaim;
};

export const claimStatusReturnPath = (claimToken: string): string =>
  `/claim-status?claimToken=${encodeURIComponent(claimToken)}`;

export const isFromClaimStatus = (search: string): boolean =>
  new URLSearchParams(search).get('from') === 'claim-status';

export const claimTokenFromSearch = (search: string): string =>
  new URLSearchParams(search).get('claimToken') || '';

export const buildClaimResumePath = (
  path: string,
  claimToken?: string | null,
  fromClaimStatus = false
): string => {
  const params = new URLSearchParams();
  if (claimToken) {
    params.set('claimToken', claimToken);
  }
  if (fromClaimStatus) {
    params.set('from', 'claim-status');
  }
  const query = params.toString();
  if (!query) {
    return path;
  }
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}${query}`;
};
